import {param2Obj} from "@/views/mixins/utils";
import {printObj} from "@/utils/debug";

/**
 * 修复el-tab跳转页面返回后默认选择第一个tab问题
 */

// 全局引用方法
export default {
    // v-tab-change:activeName="setActiveName"
    directives: {
        'tab-change': {
            // 绑定时读取query是否有action字段
            bind(el, binding) {
                let param = param2Obj(window.location.href)
                // console.log(`tab-change ${window.location.href}`)
                if (param.active) {
                    binding.value({action: 'setActiveName', key: binding.arg}, param.active);
                }
            }, // 切换时query写入action字段
            update(el, binding) {
                // setTimeout（0） 等待dom完成后进行操作
                setTimeout(() => {
                    let param = param2Obj(window.location.href)
                    // 获取dom
                    // 此处详见 注1
                    let queryList = document.querySelectorAll('.el-tabs__item')
                    for (let index = 0; index < queryList.length; index++) {
                        const item = queryList[index]
                        if (item.className.indexOf('is-active') !== -1) {
                            let activeName = item.id.split('-')[1]
                            // 防止重复调用push方法
                            if (param.active !== activeName) {
                                binding.value({action: 'setPath'}, activeName);
                            }
                        }
                    }
                }, 0);
            }
        },
    },
    methods: {
        setActiveName({action, key}, activeName) {
            // 写入tabs默认值
            if (action === 'setActiveName') {
                this[key] = activeName
            } else {
                // 使用 replace 方法防止产生记录
                this.$router.replace({
                    query: {
                        active: activeName
                    }
                })
            }

        },
    }
}